import { not, values, isEmpty, propOr, gte, lte, and, add } from 'ramda';
import { CODE_ERRORS } from '../../shared/constants'

export const checkValuesNotEmpty = obj => values(obj).every(value => not(isEmpty(value)));

export const checkServerError = error => {
  const status = propOr(0, 'status', error);
  return and(gte(status, CODE_ERRORS.INTERNAL_SERVER_ERROR), lte(status, add(CODE_ERRORS.INTERNAL_SERVER_ERROR, 99)));
}